import dashboardHomepageMenuOpen3xPng from '@listening/assets/astro/images/dashboard---homepage---menu-open3x.png';
import framePng from '@listening/assets/astro/images/Frame.png';
import frameSvg from '@listening/assets/astro/images/Frame.svg';
import frame11Svg from '@listening/assets/astro/images/Frame-1_1.svg';
import frame2Svg from '@listening/assets/astro/images/Frame-2.svg';
import frame931Png from '@listening/assets/astro/images/Frame-93-1.png';

export function ProductOverflowImageSection() {
  return (
    <section className='flex w-full items-center justify-center gap-18 overflow-hidden px-5 pt-8 pb-0 sm:p-14 lg:p-18'>
      <div className='flex max-w-[1296px] flex-1 flex-col items-center justify-center gap-8 sm:gap-14 lg:flex-row lg:gap-18'>
        <div className='flex max-w-[630px] flex-[4_1_0] flex-col gap-12 py-0 pt-5 sm:pt-0 lg:flex-1 lg:py-12'>
          <h2 className='text-[32px] leading-[34px] font-[700] text-neutral-945 sm:text-[40px] sm:leading-[43px]'>
            Listen to anything: just upload it from{' '}
            <span className='text-azure-595'>desktop or mobile</span>
          </h2>
          <div>
            <div className='flex gap-5 rounded-2xl bg-azure-455/7 p-6 sm:gap-6 lg:rounded-3xl'>
              <img alt='Icon' loading='lazy' src={frame11Svg} />
              <div className='flex flex-col gap-1'>
                <h4 className='text-[16px] leading-[21px] font-[500] text-neutral-945 sm:text-[24px] sm:leading-[32px] lg:text-[20px] lg:leading-[27px]'>
                  PDFs and Academic papers
                </h4>
                <div className='text-[16px] leading-[21px] font-[400] text-neutral-700 sm:text-[18px] sm:leading-[24px]'>
                  Upload PDFs directly on the website
                </div>
              </div>
            </div>
            <div className='flex gap-6 rounded-[24px] p-[24px]'>
              <img alt='Icon' loading='lazy' src={frameSvg} />
              <div className='flex flex-col gap-1'>
                <h4 className='text-[16px] leading-[21px] font-[500] text-neutral-945 sm:text-[24px] sm:leading-[32px] lg:text-[20px] lg:leading-[27px]'>
                  Documents: .doc, .ppt, .txt, .epub, etc
                </h4>
                <div className='text-[16px] leading-[21px] font-[400] text-neutral-700 sm:text-[18px] sm:leading-[24px]'>
                  Upload files, or click “Share” from inside your browser
                </div>
              </div>
            </div>
            <div className='flex gap-6 rounded-[24px] p-[24px]'>
              <img
                alt='Icon'
                className='size-[24px]'
                loading='lazy'
                src={framePng}
              />
              <div className='flex flex-col gap-1'>
                <h4 className='text-[16px] leading-[21px] font-[500] text-neutral-945 sm:text-[24px] sm:leading-[32px] lg:text-[20px] lg:leading-[27px]'>
                  Websites
                </h4>
                <div className='text-[16px] leading-[21px] font-[400] text-neutral-700 sm:text-[18px] sm:leading-[24px]'>
                  Click the Chrome extension on any web page to listen
                </div>
              </div>
            </div>
            <div className='flex gap-6 rounded-[24px] p-[24px]'>
              <img alt='Icon' loading='lazy' src={frame2Svg} />
              <div className='flex flex-col gap-1'>
                <h4 className='text-[16px] leading-[21px] font-[500] text-neutral-945 sm:text-[24px] sm:leading-[32px] lg:text-[20px] lg:leading-[27px]'>
                  Emails
                </h4>
                <div className='text-[16px] leading-[21px] font-[400] text-neutral-700 sm:text-[18px] sm:leading-[24px]'>
                  Forward long emails and turn them into audio
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='relative flex flex-[0_290px] flex-col items-start justify-start self-stretch overflow-hidden sm:flex-[0_550px] sm:overflow-visible lg:flex-1 lg:justify-center'>
          <div className='absolute inset-y-0 w-auto overflow-hidden sm:w-full sm:overflow-visible'>
            <img
              alt='Frame'
              className='absolute bottom-[-15px] left-[-41px] h-[33px] rounded-[35px] [box-shadow:0_4px_36px_rgba(193,_216,_251,_.5)] sm:h-[80px]'
              loading='lazy'
              src={frame931Png}
              style={{ width: 'auto' }}
            />
            <img
              alt='Dashboard Homepage Menu Open'
              className='static block h-full max-h-full max-w-none flex-1 overflow-hidden rounded-[10px] object-cover [box-shadow:0_5px_43px_rgba(193,_216,_251,_.5)] sm:rounded-[40px] lg:left-0 lg:h-full'
              loading='eager'
              src={dashboardHomepageMenuOpen3xPng}
              style={{ width: 'auto' }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
